import { useDashboard } from '../../Global/Index.js';
import Corousal from './Crousel.js';
import ClipLoader from "react-spinners/ClipLoader";

const override = {
    display: "block",
    margin: "10% auto",
    marginLeft: '40%'
};


const Offers = () => {
    const { data, isLoading, error } = useDashboard();
    if(error){
        console.log('Something went wrong');
    }

    if (isLoading) {
        return (
            <ClipLoader
                color="rgb(155,57,19)"
                loading={true}
                cssOverride={override}
                size={30}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        )
    }
    const offerlist = data?.response?.data?.offers || [];

    // const offerlist = [{offer:500}, {offer:200}, {offer:120}];
    
    return (
        <>
            {offerlist?.length === 0 ? <div style={{ margin: '2vw 0vw ' }}>No Offer Found</div> : <Corousal offerlist={offerlist} />}
        </>
    );
}

export default Offers;